module.exports = __webpack_public_path__ + "static/media/relaxed_casual.6378914c.svg";